<template>
  <b-modal id="loyalty-modal" title="Fidelidade">
    <p>
      Utilize essa função para adicionar ou remover pontos de fidelidade de
      determinado cliente.
    </p>
    <div v-if="notSelected">
      <p>O cliente já usa o aplicativo?</p>
      <div>
        <b-button
          class="mt-2 mr-2 custom-btn"
          @click="
            () => {
              notSelected = false;
              registered = true;
            }
          "
        >
          Sim
        </b-button>
        <b-button
          class="mt-2 mr-2 custom-btn"
          @click="
            () => {
              notSelected = false;
              registered = false;
            }
          "
        >
          Não
        </b-button>
      </div>
    </div>
    <div v-else>
      <b-button
        class="mb-2"
        variant="warning"
        @click="
          () => {
            notSelected = true;
            registered = null;
          }
        "
      >
        Mudar opção
      </b-button>
      <div class="d-flex">
        <b-form-input
          v-model="query"
          type="text"
          placeholder="Pesquise pelo cpf do cliente"
          pattern="[0-9]{11}"
          @keyup.enter.native="search(registered)"
        />
        <b-button
          class="ml-1 btn-align-end custom-btn"
          @click="search(registered)"
        >
          <div
            v-if="loadingSearch"
            class="spinner-border spinner-border-sm text-white"
          ></div>
          <span v-else>Pesquisar</span>
        </b-button>
      </div>
      <div v-if="user && registered">
        <p>Nome completo: {{ user.name }}</p>
        <p>Pontos atuais: {{ user.loyalty.points }}</p>
        <b-form-group
          :label="`Digite a quantidade de pontos a ser modificada para o cliente ${
            user.name.split(' ')[0]
          } e clique em uma das opções abaixo.`"
        >
          <b-form-input
            type="number"
            v-model="pointsValue"
            placeholder="15"
            min="0"
          />
          <b-button
            class="mt-2 mr-2 custom-btn"
            v-if="pointsValue > 0"
            @click="handlePointsUser(user)"
          >
            <div
              v-if="loadingChangePointsButton"
              class="spinner-border spinner-border-sm text-white"
            ></div>
            <span v-else>Adicionar pontos</span>
          </b-button>
          <b-button
            class="mt-2 mr-2 custom-btn"
            v-if="pointsValue > 0 && pointsValue <= user.loyalty.points"
            @click="handlePointsUser(user, true)"
          >
            <div
              v-if="loadingChangePointsButton"
              class="spinner-border spinner-border-sm text-white"
            ></div>
            <span v-else>Descontar pontos</span>
          </b-button>
        </b-form-group>
      </div>
      <div v-if="loyalty && registered === false">
        <p>CPF: {{ loyalty.cpf }}</p>
        <p>Pontos atuais: {{ loyalty.loyalty.points }}</p>
        <b-form-group
          :label="`Digite a quantidade de pontos a ser modificada para o cliente com CPF ${loyalty.cpf} e clique em uma das opções abaixo.`"
        >
          <b-form-input type="number" v-model="pointsValue" placeholder="15" />
          <b-button
            class="mt-2 mr-2"
            v-if="pointsValue > 0"
            @click="handlePointsLoyalty(loyalty)"
          >
            Adicionar pontos
          </b-button>
          <b-button
            class="mt-2 mr-2"
            v-if="pointsValue > 0 && pointsValue <= loyalty.loyalty.points"
            @click="handlePointsLoyalty(loyalty, true)"
          >
            Descontar pontos
          </b-button>
        </b-form-group>
      </div>
    </div>
  </b-modal>
</template>

<script>
import {
  getAccessToken,
  getActiveCompany,
  getActiveUser,
} from "@/helpers/storage";
import Locations from "@/network/locations";
import { queryUserCpf, queryLoyaltyCpf } from "@/helpers/queries";
import moment from "moment";
import { patch, get, post } from "@/network/rest";
import { showToast } from "@/helpers/toast";

export default {
  data() {
    return {
      queried: new Set(),
      query: "",
      loading: false,
      loadingSearch: false,
      loadingChangePointsButton: false,
      user: null,
      pointsValue: 0,
      notSelected: true,
      registered: null,
      loyalty: null,
    };
  },
  watch: {
    query() {
      this.query = this.query.replace(
        /(\d{3})(\d{3})(\d{3})(\d{2})/,
        (regex, a1, a2, a3, a4) => `${a1}.${a2}.${a3}-${a4}`
      );
    },
  },
  computed: {
    feathers() {
      return this.$FeathersVuex.api;
    },
    activeUser: () => getActiveUser(),
    accessToken: () => getAccessToken(),
    activeCompany: () => getActiveCompany(),
    company() {
      return this.feathers.Company.getFromStore(this.activeCompany);
    },
  },
  methods: {
    findUser(cpf) {
      this.user = null;
      this.loadingSearch = true;
      const cpfFormated = cpf.replace(/\D/g, "");
      console.log("aqui");
      const _user = this.feathers.User.findInStore({
        query: { $or: [{ cpf: cpf }, { cpf: cpfFormated }] },
      });

      if (_user.data.length) {
        this.loadingSearch = false;
        return _user.data[0];
      } else {
        if (!this.queried.has(cpf)) {
          this.queried.add(cpf);

          queryUserCpf(this.feathers, this.accessToken, cpf, this.activeCompany)
            .then((r) => {
              console.log(r);
              if (r) {
                this.user = r;
              } else {
                this.user = null;
                showToast(this, `Usuário não encontrado`, "danger");
                this.queried.delete(cpf);
              }
              this.loadingSearch = false;
            })
            .catch((e) => {
              console.log(e);
              showToast(
                this,
                `Ocorreu um problema oa buscar o usuário`,
                "danger"
              );
              this.queried.delete(cpf);
              this.loadingSearch = false;
            });
        }
      }
    },
    findLoyalty(cpf) {
      this.loyalty = null;
      this.loadingSearch = true;

      const _loyalty = this.feathers.Loyalty.findInStore({
        query: { cpf },
      });

      if (_loyalty.data.length) {
        this.loadingSearch = false;
        return _loyalty.data[0];
      } else {
        if (!this.queried.has(cpf)) {
          this.queried.add(cpf);

          queryLoyaltyCpf(
            this.feathers,
            this.accessToken,
            cpf,
            this.activeCompany
          )
            .then((r) => {
              if (r) {
                this.loyalty = r;
              } else {
                this.loyalty = {
                  cpf,
                  loyalty: {
                    points: 0,
                    history: [],
                  },
                };

                this.queried.delete(cpf);
              }
              this.loadingSearch = false;
            })
            .catch((e) => {
              showToast(
                this,
                `Ocorreu um problema oa buscar o usuário`,
                "danger"
              );
              this.loadingSearch = false;

              this.queried.delete(cpf);
            });
        }
      }
    },
    search(registered) {
      this.loading = true;

      if (registered) {
        const user = this.findUser(this.query);

        if (user) {
          this.user = user;

          this.loading = false;
        }
      } else {
        const loyalty = this.findLoyalty(this.query);

        if (loyalty) {
          this.loyalty = loyalty;

          this.loading = false;
        }
      }
    },
    handlePointsUser(user, decrement = false) {
      this.loadingChangePointsButton = true;
      const loyalty = user.loyalty || {
        points: 0,
        history: [],
      };
      const valAux1 = parseFloat(loyalty.points);
      const valAux2 = parseFloat(this.pointsValue || 0);
      const historyAux = loyalty.history ? loyalty.history : [];

      const newTotal = !decrement ? valAux1 + valAux2 : valAux1 - valAux2;

      let newLoyalty = {
        points: newTotal,
        history: [
          {
            time: moment().toISOString(),
            amount: parseFloat(this.pointsValue),
            previousAmount: loyalty.points,
            currentAmount: newTotal,
          },
        ],
      };

      newLoyalty.history = [...newLoyalty.history, ...historyAux];

      patch(this.accessToken, `${Locations.customers}/${user._id}`, {
        loyalty: newLoyalty,
      })
        .then((r) => {
          this.loadingChangePointsButton = false;
          showToast(this, `Pontos de fidelidade atualizados`, "success");
          this.resetModalState();
        })
        .catch((e) => {
          this.loadingChangePointsButton = false;
          console.log(e);
          showToast(this, `Erro ao atualizar pontos de fidelidade`, "danger");
        });
    },
    handlePointsLoyalty(_loyalty, decrement = false) {
      const loyalty = _loyalty.loyalty || {
        points: 0,
        history: [],
      };
      const valAux1 = parseFloat(loyalty.points);
      const valAux2 = parseFloat(this.pointsValue || 0);
      const historyAux = loyalty.history ? loyalty.history : [];

      const newTotal = !decrement ? valAux1 + valAux2 : valAux1 - valAux2;

      let newLoyalty = {
        points: newTotal,
        history: [
          {
            time: moment().toISOString(),
            amount: parseFloat(this.pointsValue),
            previousAmount: loyalty.points,
            currentAmount: newTotal,
          },
        ],
      };

      newLoyalty.history = [...newLoyalty.history, ...historyAux];

      if (_loyalty._id) {
        patch(this.accessToken, `${Locations.loyalty}/${_loyalty._id}`, {
          loyalty: newLoyalty,
        }).then((r) => {
          this.resetModalState();
        });
      } else {
        post(this.accessToken, Locations.loyalty, {
          ..._loyalty,
          loyalty: newLoyalty,
        }).then((r) => {
          this.resetModalState();
        });
      }
    },
    resetModalState() {
      this.$bvModal.hide("loyalty-modal");

      this.query = "";
      this.loading = false;
      this.user = null;
      this.pointsValue = 0;
      this.notSelected = true;
      this.registered = null;
      this.loyalty = null;
    },
  },
};
</script>

<style lang="scss" scoped></style>
